/**
 * Conditional-field visibility for form templates (intake trim,
 * Daniel-approved 2026-07-09).
 *
 * A field may carry `show_if: { field, equals }` or
 * `show_if: { field, not_equals }`. Semantics are progressive
 * disclosure: the field is HIDDEN until the controlling question is
 * answered, then shown when the answer matches (equals) / differs
 * (not_equals). For checkbox_group controllers, "equals" means the
 * option is checked.
 *
 * Hidden fields are skipped by required-field validation (a required
 * field inside a hidden branch must not block submission) and are NOT
 * rendered. Paper blank printing ignores show_if entirely — paper
 * can't conditionally hide, so blanks print every field.
 */
export function isFieldVisible(field, responses, patientGender) {
  // Gendered sections (e.g. HHQ Section I "For Female Patients") are
  // hidden when we KNOW the patient's sex differs. Unknown → shown
  // (fail open — paper-like behavior). Handled per-patient on the
  // client because family intake links serve one template list to
  // multiple patients of different sexes.
  if (field?.only_for_gender && patientGender
    && String(patientGender).toLowerCase() !== String(field.only_for_gender).toLowerCase()) {
    return false;
  }
  const cond = field?.show_if;
  if (!cond || !cond.field) return true;
  const v = (responses || {})[cond.field];
  const answered = !(v === undefined || v === null || v === ''
    || (Array.isArray(v) && v.length === 0));
  if (!answered) return false;
  const matches = (target) => (Array.isArray(v) ? v.includes(target) : v === target);
  if (cond.equals !== undefined) return matches(cond.equals);
  if (cond.not_equals !== undefined) return !matches(cond.not_equals);
  return true;
}
